import ACTION_CONSTANTS from "./action_constants";
import { CartItemResource } from "./resources";

export default class ActionSource {
	constructor({ dispatch, states }) {
		this.dispatch = dispatch;
		this.states = states;
	}

	clearCache = () => {
		this.dispatch({ type: ACTION_CONSTANTS.CLEAR_CACHE });
	};

	updateCart = (props) => {
		const { type = "add", product_id = null, item = {}, quantity = 1, newItem = null } = props;
		if (!["add", "sub", "remove", "replace", "swap"].includes(type)) {
			return;
		}
		const productId = product_id || item.uid || item.product_id;
		if (!productId) {
			return;
		}
		// console.log(item);
		let cartItems = [...this.states.cartItems];
		if (type == "replace") {
			cartItems = [...[]];
		}
		const removeItem = () => {
			// console.log(cartItems, CartItemResource(item).type == "package");
			const ItemIndex = cartItems.findIndex((i) => i.id === productId);
			cartItems.splice(ItemIndex, 1);
			if (cartItems.length == 0) {
				cartItems.splice(0);
				this.showSnackbar({
					visible: true,
					message: "All items are cleared automatically as all packages are removed.",
					type: "warning",
				});
			}
		};

		if (["add", "sub", "replace", "swap"].includes(type)) {
			if (item.type && item.type == "package") {
				const sameEventExists = cartItems.some((i) => i.type == "collectible");
				if (sameEventExists) {
					this.showSnackbar({
						visible: true,
						message: "You already have collectible ,To Purchase Event Tickets Clear Your Cart",
						type: "warning",
					});
					return;
				}
			}
			if (item.type && item.type == "merchandise") {
				const sameEventExists = cartItems.some((i) => i.type == "package" && i.event_id == CartItemResource(item).event_id);
				if (!sameEventExists) {
					this.showSnackbar({
						visible: true,
						message: "You need to add package before adding merchandise on the cart.",
						type: "warning",
					});
					return;
				}
			}

			if (cartItems.length > 0) {
				if (item.type && item.type == "package") {
					const sameEventExists = cartItems.filter((i) => i.type == "package").every((i) => i.event_id == CartItemResource(item).event_id);

					const sameMerchadiseExits =
						cartItems.filter((i) => i.type == "merchandise").length > 0
							? cartItems.filter((i) => i.type == "merchandise").every((i) => i.event_id == CartItemResource(item).event_id)
							: true;

					if (!sameEventExists) {
						this.showSnackbar({
							visible: true,
							message: "You have already added other event package on the cart.",
							type: "warning",
						});
						return;
					}

					if (!sameMerchadiseExits) {
						this.showSnackbar({
							visible: true,
							message: "Already add other event merchandise. Please remove first.",
							type: "warning",
						});
						return;
					}
				}
			}

			const itemExists = cartItems.some((i) => i.id === productId);
			if (itemExists) {
				// Already exists
				const ItemIndex = cartItems.findIndex((i) => i.id === productId);
				if (type == "add") {
					cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) + quantity;
				} else if (type == "replace") {
					cartItems[ItemIndex]["quantity"] = quantity;
				} else if (type == "swap") {
					if (newItem && newItem.uid) {
						// Check exists
						const newItemExists = cartItems.some((i) => i.id === newItem.uid);
						if (newItemExists) {
							const newItemIndex = cartItems.findIndex((i) => i.id === newItem.uid);
							cartItems[newItemIndex]["quantity"] = parseInt(cartItems[newItemIndex]["quantity"]) + quantity;
							removeItem();
							// Replace
						} else {
							cartItems.push(CartItemResource({ ...newItem, ...{ quantity: quantity } }));
							removeItem();
						}
					}
				} else {
					if (cartItems[ItemIndex]["quantity"] == 1) {
						// remove
						removeItem();
					} else {
						cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) - quantity;
					}
				}
			} else {
				// Not exist, need to add
				//
				cartItems.push(CartItemResource({ ...item, ...{ quantity: quantity } }));
				if (Object.values(item)[3] == "merchandise") {
					this.showSnackbar({
						visible: true,
						message: "A New Product Add on the cart.",
						type: "success",
					});
				}
			}

			// console.log("Exists::", exists);
		} else if (type == "remove") {
			// Remove the item
			removeItem();
		}

		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: cartItems });
	};

	updateBandCart = (props) => {
		const { type = "add", product_id = null, item = {}, quantity = 1, newItem = null } = props;
		const productId = product_id;
		//console.log(productId, type, quantity, newItem);
		if (!productId) {
			return;
		}

		const removeItem = () => {
			// console.log(cartItems, CartItemResource(item).type == "package");
			const ItemIndex = cartBandItems.findIndex((i) => i.id === productId);
			cartBandItems.splice(ItemIndex, 1);
			if (cartBandItems.filter((i) => i.type == "merchandise").length == 0) {
				cartBandItems.splice(0);
				this.showSnackbar({
					visible: true,
					message: "All items are cleared automatically as all packages are removed.",
					type: "warning",
				});
			}
		};

		let cartBandItems = [...this.states.cartBandItems];
		//console.log(cartBandItems);
		if (["add", "sub"].includes(type)) {
			const itemExists = cartBandItems.some((i) => i.id === productId);

			if (cartBandItems.length > 0) {
				const sameEventExists = cartBandItems.every((i) => i.event_id == CartItemResource(item).event_id);
				//console.log(cartItems, item);
				//console.log(sameEventExists);
				if (!sameEventExists) {
					this.showSnackbar({
						visible: true,
						message: "You have already added other event band merchandise on the cart.",
						type: "warning",
					});
					return;
				}
			}

			if (itemExists) {
				// Already exists
				const ItemIndex = cartBandItems.findIndex((i) => i.id === productId);
				if (type == "add") {
					cartBandItems[ItemIndex]["quantity"] = parseInt(cartBandItems[ItemIndex]["quantity"]) + quantity;
				} else {
					if (cartBandItems[ItemIndex]["quantity"] == 1) {
						// remove
						removeItem();
					} else {
						cartBandItems[ItemIndex]["quantity"] = parseInt(cartBandItems[ItemIndex]["quantity"]) - quantity;
					}
				}
			} else {
				// Not exist, need to add
				//
				cartBandItems.push(CartItemResource({ ...item, ...{ quantity: quantity } }));
				this.showSnackbar({
					visible: true,
					message: "A New Product Add on the cart.",
					type: "success",
				});
			}

			// console.log("Exists::", exists);
		} else if (type == "remove") {
			// Remove the item
			removeItem();
		}

		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_BAND_CART, payload: cartBandItems });
	};

	clearCart = () => {
		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: [] });
	};

	showSnackbar = ({ visible, message = "", options = {}, type = "success" }) => {
		this.dispatch({
			type: ACTION_CONSTANTS.HANDLE_SNACKBAR,
			payload: {
				visible,
				message,
				options,
				type,
			},
		});
	};

	updateDiscountData = (props) => {
		let data = {
			discount_code: props.discount_code || null,
			discount_amount: props.discount_amount || 0,
			event_uid: props.event_uid || null,
		};
		if (data.discount_amount == 0) {
			if (String(data.discount_code) == "alreadyused") {
				this.showSnackbar({
					visible: true,
					message: "Promo Code Already Used.",
					type: "warning",
				});
			} else {
				this.showSnackbar({
					visible: true,
					message: "Promo Code Does Not  Match.",
					type: "warning",
				});
			}
		} else {
			this.showSnackbar({
				visible: true,
				message: "Promo Code Apply Successfully.",
				type: "success",
			});
			this.dispatch({ type: ACTION_CONSTANTS.MANAGE_DISCOUNT, payload: data });
		}
	};

	clearDiscountData = () => {
		this.dispatch({ type: ACTION_CONSTANTS.MANAGE_DISCOUNT, payload: [] });
	};

	clearBandCart = () => {
		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_BAND_CART, payload: [] });
	};

	//merchandise product operation ... ...

	addToMerchandiseProduct = (props) => {
		const { type = "add", product_id = null, item = {}, quantity = 1 } = props;
		let cartItems = [...this.states.cartItems];

		const isEventExits =
			cartItems.filter((i) => i.type == "package").length > 0
				? cartItems.filter((i) => i.type == "package").some((i) => i.event_id == CartItemResource(item).event_id)
				: true;

		if (!isEventExits) {
			this.showSnackbar({
				visible: true,
				message: "You have already added other merchandise on the cart. Need to change",
				type: "warning",
			});
			return;
		}

		const itemExists = cartItems.filter((i) => i.type == "merchandise").some((i) => i.id === product_id && i.varient == CartItemResource(item).varient);
		if (itemExists) {
			const ItemIndex = cartItems.findIndex((i) => i.id === product_id && i.varient == CartItemResource(item).varient && i.type == "merchandise");
			if (type == "add") {
				cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) + quantity;
				this.showSnackbar({
					visible: true,
					message: "A item Added Successfully",
					type: "warning",
				});
			} else {
				if (cartItems[ItemIndex]["quantity"] == 1) {
					const ItemIndex = cartItems.findIndex((i) => i.id === product_id);
					cartItems.splice(ItemIndex, 1);
				} else {
					cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) - quantity;
				}

				this.showSnackbar({
					visible: true,
					message: "A item removed Successfully",
					type: "warning",
				});
			}
		} else {
			cartItems.push(CartItemResource({ ...item, ...{ quantity: quantity } }));
		}
		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: cartItems });
	};

	addToCollectibleProduct = (props) => {
		const { type = "add", product_id = null, item = {}, quantity = 1 } = props;
		let cartItems = [...this.states.cartItems];

		const collectibleCheck = cartItems.filter((i) => i.type != "collectible").length > 0 ? true : false;
		if (collectibleCheck) {
			this.showSnackbar({
				visible: true,
				message: "You have already added other products on the cart. Need to change",
				type: "warning",
			});
			return;
		}

		const itemExists = cartItems.filter((i) => i.type == "collectible").some((i) => i.id === product_id);
		if (itemExists) {
			const ItemIndex = cartItems.findIndex((i) => i.id === product_id);
			if (type == "add") {
				cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) + quantity;
				this.showSnackbar({
					visible: true,
					message: "A item Added Successfully",
					type: "warning",
				});
			} else {
				if (cartItems[ItemIndex]["quantity"] == 1) {
					const ItemIndex = cartItems.findIndex((i) => i.id === product_id);
					cartItems.splice(ItemIndex, 1);
				} else {
					cartItems[ItemIndex]["quantity"] = parseInt(cartItems[ItemIndex]["quantity"]) - quantity;
				}

				this.showSnackbar({
					visible: true,
					message: "A item removed Successfully",
					type: "warning",
				});
			}
		} else {
			cartItems.push(CartItemResource({ ...item, ...{ quantity: quantity } }));
		}
		this.dispatch({ type: ACTION_CONSTANTS.UPDATE_CART, payload: cartItems });
	};
}
